import {getCookie} from "@/utils/auth";
export const languageArr = [
    'en','zh-TC','ru','ko','ja','vi','fa','uk','es'
]
export const languageName = {
    'en':'English',
    'zh-TC':'繁體中文',
    'ru':'Русский',
    'ko':'한국어',
    'ja':'日本語',
    'vi':'Tiếng Việt',
    'fa':'فارسی',
    'uk':'Українська',
    'es':'Español'
}

export function IsShow(){
    return getCookie('language') == 'fa'?true:false
}


// WEBPACK FOOTER //
// ./src/utils/utilsType.js